import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import classNames from "classnames";
import isEmpty from "is-empty";

import { userForgotPassword } from "../actions";
import { notify } from "../../shared/actions";
import { segmentEventTracker } from '../../../utils/SegmentEventTracker'
import { TrackEventName, PageViewName } from '../../shared/constants/SegmentEvents';

import logo from "../../../assets/images/branding/logo-blue.svg";

import Layout from "../../shared/components/layouts/FullPageLayout";

class EmailSentContainer extends Component {

  state = {
    loading: false,
    error: {},
    email: (this.props.location.state || {}).email
  };

  submitButtonClassnames() {
    return classNames(
      "ds-btn",
      "--medium",
      "--full",
      {"_loading": this.state.loading},
    );
  }

  componentDidMount(){
    segmentEventTracker.trackPageView(PageViewName.FORGOT_PASSWORD_LANDING_PAGE_VIEWED);
    if (this.props.auth_token) return this.props.push("/")
    !this.state.email && this.props.push("/forgot_password")
  }

  render() {

    return (
      <Layout gridClassName="--narrow">
        <div className="logo --small _marginTop--large _marginBottom--normal">
          <img
            src={logo}
            alt="Logo"
          />
        </div>
        <div className="ds-card">
          {!isEmpty(this.state.error) && this.renderError()}
          <section className="cardSection _eventPrompt">
            <i className="materialIcon --large -primary">mail</i>
            <h1 id="subhead-content" className="subhead">Check your email</h1>
            <p id="copy-content" className="copy">We sent you an email with instructions to: { this.state.email }</p>
            <p className="copy -secondary">If you don't see our email, be sure to check your spam folders.</p>
          </section>
          <section className="cardSection">
            <p className="copy -secondary _alignCenter">
              Didn't receive a reset link?
              <a id="resend-link"
                className="inlineLink"
                onClick={ this.resendPasswordLink }
                data-testid="resend-password-link-button">
                  Resend reset link
              </a>
            </p>
          </section>
          <a
            id="btn-to-login"
            className="ds-btn --full"
            onClick={this.onBackToLogin}
            data-testid="go-back-to-login-button"
          >
            Go back to Login Page
          </a>
        </div>
      </Layout>
    );
  }

  onBackToLogin = () => {
    segmentEventTracker.trackEvent(TrackEventName.GO_BACK_TO_LOGIN_PAGE_CLICKED);
    this.props.push("/login")
  }

  resendPasswordLink = () =>{
    segmentEventTracker.trackEvent(TrackEventName.RESEND_PASSWORD_LINK_CLICKED);
    this.props.userForgotPassword( { email: this.state.email } )
  }
}

const mapStateToProps = (state) => {
  return {
    auth_token: state.user.auth_token,
  };
};

const matchDispatchToProps = (dispatch, props) => {
  return {
    userForgotPassword: (payload)                       => dispatch( userForgotPassword( payload ) ),
    push:               (path, payload)                 => dispatch( push({ pathname: path, state: payload}) ),
    notify:             (payload)                       => dispatch( notify(payload) )
  };
};
export default connect(mapStateToProps, matchDispatchToProps)(EmailSentContainer);



// WEBPACK FOOTER //
// ./src/features/user/containers/EmailSent.js